import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useEvieAppContext } from '../EvieAppProvider';
import ContentCard from '../ContentCard';

const AdditionalContent = ({ isProgram }) => {
  const { t } = useTranslation();
  const { additionalContent = [] } = useEvieAppContext();

  return (
    <>
      {isProgram ? <h2 className="additional-content_title">{t('evieApp.program.additionalContent')}</h2> : null}
      <section className="additional-content">
        {additionalContent.map((task) => (
          <ContentCard key={task.id} task={task} isProgram={isProgram} />
        ))}
      </section>
    </>
  );
};

AdditionalContent.defaultProps = {
  isProgram: false,
};

AdditionalContent.propTypes = {
  isProgram: PropTypes.bool,
};

export default AdditionalContent;
